
import { APP_CONTEXT, PAGE_TYPES } from '../../Context/constants';

import { prospectPlatforms } from './constants';

const Views = self => ({
  get app() {
    if (self.context.appContext === APP_CONTEXT.SEARCH) {
      return self.search;
    }

    return self.prospecting;
  },

  get contact() {
    if (self.context.appContext === APP_CONTEXT.PROSPECT) {
      if (self.context.isLinkedinCompany || prospectPlatforms.includes(self.userSettings.platform)) {
        if (self.context.type === PAGE_TYPES.PROFILE) {
          return self.contextContact;
        }

        return self.app.contact;
      }

      return self.contextContact;
    }

    return self.app.contact;
  },

  get company() {
    if (self.context.appContext === APP_CONTEXT.PROSPECT) {
      if (self.context.isLinkedinCompany || prospectPlatforms.includes(self.userSettings.platform)) {
        if (self.context.type === PAGE_TYPES.PROFILE) {
          return self.contextContact.company;
        }

        return self.app.company;
      }

      return self.contextContact.company;
    }

    return self.app.company;
  },
});

export default Views;
